import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DynamicRecipeModels } from '@pdqdev/pdq-shared/dist/interfaces';
import { DropdownOption } from '../../../../../../storybook/components/dropdown/dropdown.component';
import { VariableWithValues } from '../recipe-editor.component';

@Component({
  selector: 'dropdown-variable',
  templateUrl: './dropdown-variable.component.html',
  styleUrls: ['./dropdown-variable.component.scss'],
  standalone: false,
})
export class DropdownVariableComponent implements OnInit, OnChanges {
  @Input() variable: DynamicRecipeModels.Variable;

  @Output() onVariableChange = new EventEmitter<VariableWithValues>();

  InputType = DynamicRecipeModels.InputType;
  inputConfig: DynamicRecipeModels.SelectInputConfig | DynamicRecipeModels.MultiSelectInputConfig;
  isMultiSelect: boolean;
  isValid: boolean;
  valuesForm: UntypedFormGroup;
  initialSelectedValues: string[];
  readonly DROP_DOWN_LABEL_THRESHOLD: number = 1;
  constructor() {}

  ngOnInit(): void {
    this.initProps();
    this.initForm();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.variable) {
      // this.initProps();
    }
  }

  onMultiSelectChange(options: DropdownOption[]) {
    if (!this.isMultiSelect) {
      return;
    }

    this.setValues(options.map((option) => (option.checked ? `${option.value}` : null)).filter(Boolean));
  }

  onSingleSelectChange(option: DropdownOption) {
    if (this.isMultiSelect) {
      return;
    }

    this.setValues([`${option.value}`]);
  }
  private initForm() {
    const initialValues = this.isMultiSelect
      ? (this.inputConfig as DynamicRecipeModels.MultiSelectInputConfig)?.selectedValues
      : [(this.inputConfig as DynamicRecipeModels.SelectInputConfig)?.selectedValue];

    this.valuesForm = new UntypedFormGroup({
      selectedValues: new UntypedFormControl(initialValues.filter(Boolean)),
    });
  }
  private setValues(values: string[]) {
    const isValid = values.length;

    this.valuesForm.controls.selectedValues.setValue(values);
    this.valuesForm.setErrors(isValid ? null : { required: true });

    const selectedValues = this.valuesForm.value.selectedValues;
    const resVaribable: VariableWithValues = {
      ...this.variable,
      isValid: selectedValues.length > 0,
    };
    this.isMultiSelect
      ? ((resVaribable.inputConfig as DynamicRecipeModels.MultiSelectInputConfig).selectedValues = selectedValues)
      : ((resVaribable.inputConfig as DynamicRecipeModels.SelectInputConfig).selectedValue = selectedValues[0]);

    this.onVariableChange.emit(resVaribable);
  }
  private initProps() {
    this.isMultiSelect = this.variable?.type === DynamicRecipeModels.InputType.MULTI_SELECT;
    this.inputConfig = this.variable?.inputConfig;
    this.initialSelectedValues = this.isMultiSelect
      ? [...(this.inputConfig as DynamicRecipeModels.MultiSelectInputConfig)?.selectedValues]
      : [(this.inputConfig as DynamicRecipeModels.SelectInputConfig)?.selectedValue];

    this.initialSelectedValues = this.initialSelectedValues.filter(Boolean);
  }
}
